import React from 'react';
import styled from 'styled-components';
import Tip from '@/components/Tip';

/**
 *
 * @param {Object} props
 * @param {string} [props.title] 标题
 * @param {*} [props.tip] 提示
 * @param {Object} [props.titleStyle] 标题样式覆盖
 * @param {*} [props.actions] 操作区
 * @param {boolean} [props.bordered] 是否边框
 * @returns
 */
export default function Panel({ bordered, title, tip, titleStyle, children, actions, ...others }) {
  return (
    <Root {...others} className='descriptions' bordered={bordered}>
      {title && (
        <H3 className='descriptions-title' content={tip} style={titleStyle}>
          {bordered && <Rect />}
          <Title>{title}</Title>
          <Action>{actions}</Action>
        </H3>
      )}
      {children}
    </Root>
  );
}

const Root = styled.div`
  ${(props) =>
    props.bordered &&
    `
      padding: 16px;
      border-radius: 6px;
      border: 1px solid rgba(32, 43, 64, 0.08);
    `}
`;

const H3 = styled(Tip)`
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  color: var(--td-font-gray-1);
  padding-bottom: 6px;
  display: inline-flex;
  align-items: center;
  width: 100%;
`;

const Rect = styled.div`
  background: var(--td-brand-color-7);
  height: 20px;
  margin: 0 12px 0 -16px;
  width: 3px;
`;

const Title = styled.div`
  flex: 1;
`;

const Action = styled.div``;
